import { render, staticRenderFns } from "./chooseDoctor.vue?vue&type=template&id=98bfa8a0&scoped=true"
import script from "./chooseDoctor.vue?vue&type=script&lang=js"
export * from "./chooseDoctor.vue?vue&type=script&lang=js"
import style0 from "./chooseDoctor.vue?vue&type=style&index=0&id=98bfa8a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98bfa8a0",
  null
  
)

export default component.exports